module.exports = __webpack_public_path__ + "img/Add_pinkgradient_icon.020c832a.png";